module.exports = __webpack_public_path__ + "static/main-fed7a53d94a739acecce7a18f6e3250d.png";